import { useProfile } from '@/hooks/useProfile';

export function useMembershipStatus() {
  const { data: profile, isLoading } = useProfile();

  // Fail closed: if we don't have a profile yet, treat as pending.
  const status = profile?.membership_status || 'pending';

  return {
    status,
    isPending: status === 'pending',
    isApproved: status === 'approved',
    isRejected: status === 'rejected',
    isApplied: status === 'applied',
    isLoading,
  };
}
